<template lang="pug">
    form
        input(
            type="file"
            id="fileUpload"
            accept="audio/mp3"
            @change="input"
            )
</template>

<script>
    export default {
        props: {
            value: {
                type: [String, File, null],
                default: null,
            },
            loadText: {
                type: String,
                default: 'Загрузить изображение',
            },
            removeText: {
                type: String,
                default: 'Удалить изображение',
            },
        },
        methods: {
            input(e) {
                const files = e.target.files || e.dataTransfer.files;
                if (!files.length) {
                    return;
                }
                this.$emit('input', files[0]);
            },
        },
    };
</script>

<style lang="scss" scoped>
    form {
        display: flex;
        width: 100%;
        margin: 20px 0px;
    }
    input[type='file']::file-selector-button {
        color: #fff;
        border: 2px solid hsl(121, 38%, 58%);
        padding: 10px 15px;
        border-radius: 5px;
        background-color: hsl(121, 38%, 58%);
        transition: 0.5s;
        &:hover {
            background-color: hsl(121, 33%, 48%);
        }
    }
</style>
